import { render, staticRenderFns } from "./AutoCollectSettings.vue?vue&type=template&id=52313b55&scoped=true"
import script from "./AutoCollectSettings.vue?vue&type=script&lang=js"
export * from "./AutoCollectSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52313b55",
  null
  
)

export default component.exports